import { Flex, FloraButton } from '@grupoboticario/flora-react';
import { ArrowLeftIcon } from '@grupoboticario/flora-react-icons';
import { useNavigate } from 'react-router-dom';

import { ResponsiveFloraTypography } from 'components/ResponsiveFloraTypography';
import { useRegistrationControllerContext } from 'store';

import type { ActionsParams } from '../Actions';

export const BackToEdit = ({ type, hierarchy }: ActionsParams) => {
  const { handleCorrectData } = useRegistrationControllerContext();
  const navigate = useNavigate();

  const handleOnClick = () => {
    handleCorrectData();
    navigate(`/perfil/editar/${type}/confirmacao`, { replace: true });
  };

  return (
    <Flex direction='column'>
      <FloraButton
        autotagging-flora='on'
        data-flora='button'
        data-flora-text={`corrigir-${type}`}
        hierarchy={hierarchy}
        has='iconLeft'
        icon={<ArrowLeftIcon size='16' aria-hidden />}
        onClick={handleOnClick}
      >
        <ResponsiveFloraTypography fontWeight='bold'>Corrigir {type}</ResponsiveFloraTypography>
      </FloraButton>
    </Flex>
  );
};
